module.exports = __webpack_public_path__ + "rosacea_3_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/rosacea_3_after_tn.jpg
// module id = 1449
// module chunks = 0